"use client";

import { useId } from "react";
import { confirmationSequence } from "../confirmation-sequence";
import { suppliedConsentKeys, type SuppliedConsentChoices } from "../supplied-documents";

export type SensitiveConsentSelections = Record<keyof SuppliedConsentChoices, boolean | undefined>;

const titles = {
  identity: "实名认证所需的敏感身份信息",
  face: "本人身份及活体核验所需的人脸信息",
  materials: "主动上传的敏感肖像、声音及其他生物识别信息",
  financial: "收益结算所需的金融账户信息",
};

export function SensitiveConsentChoice({ index, text, choices, onChange, disabled = false }: {
  index: number;
  text: string;
  choices: SensitiveConsentSelections;
  onChange: (index: number, value: boolean) => void;
  disabled?: boolean;
}) {
  const id = useId();
  const key = suppliedConsentKeys[index];
  const unlocked = confirmationSequence(suppliedConsentKeys, item => choices[item] === true).isUnlocked(index);
  return <fieldset disabled={disabled || !unlocked} data-consent-pending={choices[key] !== true ? "true" : undefined} aria-describedby={`${id}-purpose`} className="my-1 min-w-0 rounded-xl border border-[var(--color-line)] px-3 pb-2 pt-1">
    <legend className="px-2 text-sm font-semibold leading-6">{String.fromCharCode(65 + index)}. {titles[key]}</legend>
    <div className="flex flex-wrap gap-x-4 gap-y-1">
      {([true, false] as const).map(value => <label key={String(value)} className="inline-flex min-h-11 cursor-pointer items-center gap-2 text-sm">
        <input type="radio" name={id} value={String(value)} checked={choices[key] === value}
          className="h-4 w-4 accent-[var(--color-accent)]" onChange={() => onChange(index, value)} />
        {value ? "单独同意" : "不同意"}
      </label>)}
    </div>
    <p id={`${id}-purpose`} className="mt-0 text-sm leading-6 text-[var(--color-muted)]">{text}</p>
  </fieldset>;
}
